module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_piolink_m2.d851b4170090030ced6d8c9480672306.png";